import { useState, useCallback } from 'react';
import { useKey } from 'react-use';

// TODO: refactor hook in HB-5923
export function useRevertToPrev<SelectedOption>({
  selectedOption,
  setSelected,
}: {
  selectedOption: SelectedOption | null;
  setSelected: (selectedOption: SelectedOption | null) => void;
}) {
  const [prevOptions, setPrevOptions] = useState<SelectedOption | null>(null);
  const updatePrevOptions = useCallback(() => {
    setPrevOptions(selectedOption);
  }, [selectedOption]);

  const handleKeyDown = useCallback(() => {
    setSelected(prevOptions);
  }, [selectedOption, prevOptions]);

  useKey('Escape', handleKeyDown, { options: { capture: true }, event: 'keydown' }, [handleKeyDown]);

  return { updatePrevOptions };
}
